export default "__VITE_ASSET__D$2l1EZD__"